<template>
  <div class="option">
    <h4 class="showTitle">{{ theme }}</h4>
    <div class="buttons__wrapper">
      <div class="marker"
        :style="{
          transform: `translate(${(value === 1) ? 102 : 6}%, 6%) scale(${active === theme ? 1 : 0})`,
          opacity: ((active === theme)) ? 1 : 0,
          background: value === 1 
            ? 'linear-gradient(-45deg, yellowgreen, green)'
            : 'linear-gradient(-45deg, tomato, darkred)'
        }"
      />
      <button
        v-for="button in buttons"
        :key="`button-${theme}-${button.label}`"
        :class="{
          buttons__button: true,
          ['buttons__button--active']: (button.value === value) && (active === theme)
        }"
        @click="setThemeValue(button.value)"
      >{{ button.label }}</button>

    </div>
  </div>

</template>


<script>
export default {
  name: 'theme-row',
  props: {
    theme: {
      type: String,
      required: true,
    },
  },
  components: {},
  data () {
    return {
      value: null,
      buttons: [],
      active: null,
    }
  },

  methods: {
    setThemeValue (value) {
      if ((this.theme === this.active) && (value === this.value)) {
        this.active = null
        this.value = null
        this.$emit('unvote', { theme: this.theme })
        return
      }
      this.value = value
      this.active = this.theme
      this.$emit('vote', { value: this.value, theme: this.theme })
    },
  },
  computed: {},

  mounted () {
    this.$nextTick(() => {
      this.buttons = this.$root.content.buttonValues
    })
  },
}
</script>


<style scoped lang="sass">
@import index

.option
  flex: 1 1 0
  // padding-right: 16px
  margin-bottom: 24px
  display: flex
  flex-direction: column
  align-items: center
  .showTitle
    color: white
    text-align: center
    font-size: 20px
    line-height: 24px
    margin-bottom: 12px
    &:first-letter
      text-transform: uppercase

.buttons
  &__wrapper
    // background: $color-grey-1
    border-radius: 100px
    // padding: 0 4px
    margin-top: auto
    width: 120px
    height: 40px
    overflow: hidden
    border: solid 1px rgba(white, 0.4)
    background: rgba(black, 0.3)
    .marker
      transition: all 300ms
      position: absolute
      top: 0
      left: 0
      width: 49%
      height: 86%
      transform: translate(50%, 10%) scale(0)
      border-radius: 100px

  &__button
    // margin: 0 4px
    padding: 0 // 4px 0px
    width: 49%
    height: 100%
    border-radius: 100px
    background: none
    border: none
    color: white !important
    &--active


</style>



// WEBPACK FOOTER //
// src/components/got-show-matcher/theme-row.vue